<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Report</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-for="field in fields" v-slot:[`cell(${field.key})`]="{ item }">{{ item[field.key] }}</template>
                <template v-slot:row-details="data">
                  <p><strong>Total Cost: </strong> {{ format(data.item.details.totalCost, '0,0.00') }}</p>
                  <template v-for="(v, k, i) in data.item.details.result">
                    <p :key="`txt-table-${i}`"><strong>Draw Name:</strong> {{ k }}</p>
                    <b-table-simple :key="`table-${i}`" hover small responsive bordered borderless>
                      <b-thead head-variant="dark">
                        <b-tr>
                          <b-th >Total Cost</b-th>
                          <b-th v-for="(val, index) in v" :key="`th-${index}`">{{ val.Gift }}</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr>
                          <b-td variant="info">{{ format(getCost(v), '0,0.00') }}</b-td>
                          <b-td v-for="(val, index) in v" :key="`td-${index}`">Count - {{ format(val.Count, '0,0') }} <br /> Cost - {{ format(val.Cost, '0,0.00') }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <hr :key="`hr-table-${i}`"/>
                  </template>
                </template>
                <template v-slot:cell(Operate)="data">
                  <b-btn variant="success" class="btn-sm" @click="getDetail(data.item)">
                    <i class="fa fa-eye"></i>
                  </b-btn>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../../events.js'
import VueNotifications from 'vue-notifications'
import numeral from 'numeral'
const moment = require('moment-timezone')
const _ = require('underscore')
export default {
  name: 'scratchcard-report-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Operate', label: 'Operate'},
        {key: 'AddTime', label: 'Report Date'}
      ],
      perPage: 50,
      currentPage: 1,
      sStartTime: moment().subtract(1, 'days').tz('Asia/Taipei').format('YYYY-MM-DD'),
      sEndTime: moment().subtract(1, 'days').tz('Asia/Taipei').format('YYYY-MM-DD')
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (item) {
      return item.length
    },
    getCost (list) {
      return _.reduce(list, function (p, n) { return p + parseFloat(n.Cost) }, 0)
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `from=${this.sStartTime}&to=${this.sEndTime}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/report/promotion/luckywheel?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        let $this = this.fields
        data.columns.forEach(function (x) {
          $this.push({ key: x, label: x })
        })
        this.items = data.result
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getDetail (item) {
      try {
        Events.$emit('loader')
        if (item._showDetails) {
          item._showDetails = false
          return
        } else {
          let queryStr = `date=${item.AddTime}`
          let { data } = await this.$http.get(this.API_ENDPOINT + '/report/promotion/luckywheel/detail?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
          item.details = data
          this.items.forEach(x => { this.$set(x, '_showDetails', false) })
          this.$set(item, '_showDetails', true)
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    }
  },
  async created () {
    await this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/report/mini-games/luckywheel/LuckyWheelReportTable.vue